import { useMemo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { formatPercent } from './geographicSalesIntelligenceUtils'

export default function GeographicSalesIntelligenceLocalMarket({
  localVsOutOfMarket,
  localMarketMiles,
}) {
  const local = localVsOutOfMarket?.local || { buyers: 0, percent: 0 }
  const outOfMarket = localVsOutOfMarket?.outOfMarket || {
    buyers: 0,
    percent: 0,
  }

  const options = useMemo(
    () => ({
      chart: {
        type: 'pie',
        height: 280,
        backgroundColor: 'transparent',
        spacing: [8, 8, 8, 8],
      },
      title: { text: undefined },
      credits: { enabled: false },
      tooltip: {
        pointFormat: '<b>{point.y}</b> buyers ({point.percentage:.1f}%)',
      },
      plotOptions: {
        pie: {
          innerSize: '62%',
          borderWidth: 0,
          dataLabels: { enabled: false },
        },
      },
      series: [
        {
          name: 'Buyers',
          data: [
            {
              name: 'Local',
              y: Number(local.buyers) || 0,
              color: '#3E8BF7',
            },
            {
              name: 'Out of Market',
              y: Number(outOfMarket.buyers) || 0,
              color: '#d1d5db',
            },
          ],
        },
      ],
    }),
    [local.buyers, outOfMarket.buyers]
  )

  const total = Number(local.buyers) + Number(outOfMarket.buyers)
  if (!total) {
    return (
      <p className="text-muted small mb-0">
        Local buyers are those within {localMarketMiles || 50} miles of the
        venue.
      </p>
    )
  }

  return (
    <div className="geo-local-market">
      <HighchartsReact highcharts={Highcharts} options={options} />
      <ul className="geo-local-market__legend">
        <li>
          <span className="geo-local-market__swatch geo-local-market__swatch--local" />
          Local
          <strong>{formatPercent(local.percent)}</strong>
        </li>
        <li>
          <span className="geo-local-market__swatch geo-local-market__swatch--away" />
          Out of Market
          <strong>{formatPercent(outOfMarket.percent)}</strong>
        </li>
      </ul>
    </div>
  )
}
